import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Reload ")
const _hoisted_2 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_channel_card = _resolveComponent("add-channel-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-py-xl container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_q_dialog, {
          modelValue: $setup.addChannelDialog,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.addChannelDialog) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_add_channel_card, { onChannel: $setup.onAddChannel }, null, 8, ["onChannel"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_q_table, {
          style: {"max-height":"calc(100vh - 146px)"},
          title: "Channels",
          "row-key": "name",
          rows: $setup.channels,
          columns: [
          {
            name: 'name',
            label: 'Name',
            field: 'name',
          },
          {
            name: 'updatedAt',
            label: 'Last Update',
            field: 'updatedAt',
            format: value => new Date(value).toLocaleString(),
          },
          {
            name: 'actions',
            label: 'Actions',
            field: 'actions',
          }
        ],
          loading: $setup.loading,
          "virtual-scroll": "",
          "virtual-scroll-slice-size": "5",
          "virtual-scroll-item-size": 48,
          "virtual-scroll-sticky-size-start": 48,
          "rows-per-page-options": [0],
          onVirtualScroll: $setup.onScroll
        }, {
          "top-right": _withCtx(() => [
            _createVNode(_component_q_input, {
              borderless: "",
              dense: "",
              autofocus: "",
              debounce: "250",
              modelValue: $setup.nameFilter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.nameFilter) = $event)),
              placeholder: "Search by name"
            }, {
              append: _withCtx(() => [
                ($setup.nameFilter !== '')
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      tag: "button",
                      class: "q-field__focusable-action",
                      name: $setup.matClose,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.nameFilter = ''))
                    }, null, 8, ["name"]))
                  : (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      name: $setup.matSearch
                    }, null, 8, ["name"]))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_btn, {
              label: "Add channel",
              color: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.addChannelDialog = true))
            }),
            _createVNode(_component_q_btn, {
              icon: $setup.matRefresh,
              onClick: $setup.onRefresh,
              "aria-label": "Reload",
              flat: "",
              round: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["icon", "onClick"])
          ]),
          "body-cell-actions": _withCtx((item) => [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_q_btn, {
                round: "",
                flat: "",
                color: "red",
                icon: $setup.matDelete,
                onClick: ($event: any) => ($setup.onDeleteChannel(item))
              }, null, 8, ["icon", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["rows", "columns", "loading", "onVirtualScroll"])
      ])
    ]),
    _: 1
  }))
}